import { Typography } from '@riac/design-system';
import React from 'react';

export const SkipLink = () => {
  return (
    <div className='w-fit absolute left-2 right-2 p-1 bg-black/70 -z-10 opacity-0 focus-within:opacity-100 focus-within:z-10 transition-all'>
      <a href='#maincontent' className='dark'>
        <Typography color='text' size='lg' weight='bold'>Skip to main content</Typography>
      </a>
    </div>
  );
};
